<template>
  <div>
    <!-- Annual title -->
    <div class="toggle__title annual" v-if="planName == 'annual'">
      <div>
        <div class="toggle__title__main">
          Annual plans
        </div>
        <div class="toggle__title__subtitle">
          The best value for money plans. Save from 67%.
        </div>
      </div>
    </div>
    <!-- Monthly title -->
    <div class="toggle__title monthly" v-if="planName == 'monthly'">
      <div>
        <div class="toggle__title__main">
          Monthly plans
        </div>
        <div class="toggle__title__subtitle">
          Pay monthly as you go. Cancel anytime.
        </div>
      </div>
    </div>
    <!-- educational title -->
    <div class="toggle__title educational" v-if="planName == 'educational'" :class="{'toggle_title_edu_mobile': isMobile}">
      <div>
        <div class="toggle__title__main">
          Educational plans
        </div>
        <div
          class="toggle__title__subtitle"
        >
          Special pricing for teachers, students, and nonprofit organisations. Billed annually.
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    planName: {
      type: String,
      default: 'annual',
    },
    showTitleOpenEdu: {
      type: Boolean,
      default: true,
    },
    isMobile: {
      type: Boolean,
      default: true,
    },
  },
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";

.toggle__title {
  text-align: left;
}

@media (max-width: 1280px) {
  .toggle__title {
    text-align: center !important;
    margin-top: 10px !important;
  }
}

.toggle__title__main {
  color: rgba(0, 0, 0, 0.75);
  font-weight: bold;
  font-size: 30px;
  margin-bottom: 8px;
}

.toggle__title__subtitle {
  color: rgba(0, 0, 0, 0.75);
}

@media (max-width: 479px) {
  .toggle__title__main {
    display: none;
  }
  .toggle__title__subtitle {
    font-size: 14px;
  }
  .toggle_title_edu_mobile{
    padding-left: 10px;
    padding-right: 10px;
    text-align: left;
    .toggle__title__main{
      font-size: 24px;
      font-weight: 700;
      font-style: normal;
      text-align: left;
      display: block;
    }
    .toggle__title__subtitle{
      font-size: 14px;
      font-weight: 400;
      text-align: left;
      font-style: normal;
    }
  }
}

</style>
